<template>
  <el-pagination
  	class="paginator"
    background
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :page-sizes="[10, 20, 50, 100]"
    layout="total, sizes, prev, pager, next, jumper"
    :current-page.sync="currentPage"
    :page-size="limit"
    :total="total"
    :small="small"
	:pager-count="pagerCount"
	>
  </el-pagination>
</template>
<script>
  export default {
    name: 'Pagination',
    data() {
	    return {
	      currentPage: 1
	    }
	  },
    props: {
      'total': {
	      required: false,
	      default: 0
	    },
	    'limit': {
	      required: false,
	      default: 10
	    },
	    'small': {
			required: false,
	      type: Boolean,
	      default: false
	    },
		'pagerCount': {
			default: 5
		},
    },
    watch: {
	    currentPage(val) {
				// 改变这个值并不会触发 handleCurrentChange
				console.log(val)
	      if (typeof val === "number") {
	        this.currentPage = val;
	      }
		  // 解决删除末页后 父级pagenum不变的情况
		  this.$emit("currentPageChange", val)
			},
			deep:true
	  },
    methods: {
      handleSizeChange(val) {
      	this.currentPage = 1;
	      this.$emit("handleSizeChange", val);
        console.log(`每页 ${val} 条`);
	    },
	    handleCurrentChange(val) {
	      this.$emit("handleCurrentChange", val);
	      console.log(`当前页: ${val}`);
	    },
	    changePageNo() {
        this.currentPage = 1;
	    },
    }
  };
</script>
<style lang="scss" scoped>
	@import './paginator.scss';
</style>



// WEBPACK FOOTER //
// src/components/paginator/paginator.vue